import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-we-do',
  templateUrl: './we-do.component.html',
  styleUrls: ['./we-do.component.scss'],
  standalone: false,
})
export class WeDoComponent {
  @Input() logo: string = '';
  @Input() heading: string = '';
  @Input() highlight: string = '';
  @Input() points: string[] = [];
  @Input() imageLink: string = '';
  @Input() linkText: string = '';
  @Input() link: string = '';
  @Input() isMorning: boolean = false;
  @Input() data: any;

  @ViewChild('featureContainer') featureContainer!: ElementRef;
  @ViewChild('featureImage') featureImage!: ElementRef;

  scrollPosition: number = 0;
  activeCardIndex = 0;
  previousCardIndex: number | null = null;
  isTransitioning = false;
  intervalId: any;

  containerTop: number = 0;
  containerHeight: number = 0;
  containerBottom: number = 0;
  windowHeight: number = 0;
  imageHeight: number = 0;
  isBrowser: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  ngOnInit() {
    this.startCarousel();
    this.isBrowser = isPlatformBrowser(this.platformId);
    if (this.isBrowser) {
      this.windowHeight = window.innerHeight;
    }
  }

  ngAfterViewInit() {
    if (this.isBrowser) {
      setTimeout(() => {
        this.updateMeasurements();
      }, 100);
    }
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  updateMeasurements() {
    if (this.featureContainer && this.featureImage) {
      const containerRect =
        this.featureContainer.nativeElement.getBoundingClientRect();
      const imageRect = this.featureImage.nativeElement.getBoundingClientRect();

      if (this.isBrowser) {
        this.containerTop = containerRect.top + window.scrollY;
        this.containerHeight = containerRect.height;
        this.containerBottom = this.containerTop + this.containerHeight;
        this.imageHeight = imageRect.height;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (this.isBrowser) {
      this.windowHeight = window.innerHeight;
    }
    this.updateMeasurements();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (this.isBrowser) {
      this.scrollPosition = window.scrollY;
      document.documentElement.style.setProperty(
        '--scroll-position',
        `${this.scrollPosition}px`
      );
    }
  }

  updateStickyImage() {
    if (!this.featureImage) return;

    const imageElement = this.featureImage.nativeElement;
    const padding = 20; // Top padding when sticky

    // Calculate boundaries
    const startPosition = this.containerTop;
    const endPosition = this.containerBottom - this.imageHeight;

    if (
      this.scrollPosition > startPosition &&
      this.scrollPosition < endPosition
    ) {
      // In the sticky range - fix the image
      imageElement.style.position = 'fixed';
      imageElement.style.top = `${padding}px`;
      imageElement.style.bottom = 'auto';
    } else if (this.scrollPosition >= endPosition) {
      // Past the sticky range - lock to bottom
      imageElement.style.position = 'absolute';
      imageElement.style.top = 'auto';
      imageElement.style.bottom = '0';
    } else {
      // Before the sticky range - position at top
      imageElement.style.position = 'absolute';
      imageElement.style.top = '0';
      imageElement.style.bottom = 'auto';
    }
  }

  startCarousel() {
    if (this.isBrowser) {
      this.intervalId = setInterval(() => {
        this.isTransitioning = true;
        this.previousCardIndex = this.activeCardIndex;

        setTimeout(() => {
          this.activeCardIndex = (this.activeCardIndex + 1) % this.data.length;
          setTimeout(() => {
            this.isTransitioning = false;
          }, 500);
        }, 500);
      }, 5000);
    }
  }

  getCardClass(index: number) {
    // Current visible card
    const isActive = index === this.activeCardIndex;
    // Previous card that's animating out
    const isLeaving = this.isTransitioning && index === this.previousCardIndex;
    // Next card that's coming in
    const isEntering = this.isTransitioning && index === this.activeCardIndex;

    if (isActive && !this.isTransitioning) {
      return 'card-visible';
    } else if (isLeaving) {
      return 'card-leaving';
    } else if (isEntering) {
      return 'card-entering';
    } else {
      return 'card-hidden';
    }
  }
}
